import { ClickableImage } from './ClickableImage'

type Props = {
  url: string
}

export function LabelResultSampleImage({ url }: Props) {
  return <ClickableImage src={url} alt="見本画像" />
}
